module.exports = __webpack_public_path__ + "img/Greece.f67eca9d.png";